import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../card/Card";
import { TabsContent } from "../tabs/Tabs";

const OverviewTabContent = ({
  value,
  title,
  description,
  subDescription = null,
  options = null,
  children,
}) => {
  return (
    <TabsContent value={value}>
      <Card>
        <CardHeader>
          <div className="flex flex-row justify-between">
            <div className="flex flex-col gap-y-1">
              <CardTitle>{title}</CardTitle>
              <CardDescription>
                {description}
                {subDescription && <p>{subDescription}</p>}
              </CardDescription>
            </div>
            {options}
          </div>
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </TabsContent>
  );
};

export default OverviewTabContent;
